import './feedback-widget.scss';

import { createPortal } from 'react-dom';
import { useLocation } from 'react-router';

import { ISADMINLOGGED } from '@/constants/global';

import FeedbackForm from './FeedbackForm';
import { useFeedbackContext } from './FeedbackProvider';

const AUTH_PATHS = ['/', '/verify-otp'];

const FeedbackWidget = () => {
	const { isWidgetOpen, openWidget, closeWidget } = useFeedbackContext();
	const location = useLocation();

	// Don't render on auth pages or when not logged in
	if (AUTH_PATHS.includes(location.pathname) || !ISADMINLOGGED()) {
		return null;
	}

	return createPortal(
		<div data-feedback-widget='true'>
			{/* Floating button */}
			<button
				className='feedback-widget-button'
				onClick={isWidgetOpen ? closeWidget : openWidget}
				aria-label={isWidgetOpen ? 'Close feedback' : 'Send feedback'}
			>
				{isWidgetOpen ? (
					<svg
						viewBox='0 0 24 24'
						fill='none'
						stroke='currentColor'
						strokeWidth='2'
					>
						<line
							x1='18'
							y1='6'
							x2='6'
							y2='18'
						/>
						<line
							x1='6'
							y1='6'
							x2='18'
							y2='18'
						/>
					</svg>
				) : (
					<svg
						viewBox='0 0 24 24'
						fill='none'
						stroke='currentColor'
						strokeWidth='2'
					>
						<path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />
						<line
							x1='12'
							y1='8'
							x2='12'
							y2='12'
						/>
						<line
							x1='8'
							y1='10'
							x2='16'
							y2='10'
						/>
					</svg>
				)}
			</button>

			{/* Panel */}
			{isWidgetOpen && (
				<div className='feedback-widget-panel'>
					<FeedbackForm />
				</div>
			)}
		</div>,
		document.body
	);
};

export default FeedbackWidget;
